module.exports = __webpack_public_path__ + "img/circle_caret_up_icon.00b239ad.svg";